import { Controller } from '@hotwired/stimulus'

// Tabla de cotizaciones (PDT-RNK-6549). En móvil la tabla se desliza en
// horizontal y, como ya se leen enteros nombre, precio y variación, podría
// parecer terminada: un degradado gris sobre el borde derecho avisa de que quedan
// columnas. Este controlador lo enciende (`is-overflowing`, el CSS lo pinta)
// mientras queda contenido oculto y lo apaga al llegar al final, para que la
// última columna se lea entera. Sin JS la tabla se desliza igual, sin degradado.
//
// Es la lógica de `cotiz_selector_controller.js` sin su `revealActive()`: en la
// tabla `.is-active` lo lleva la cabecera por la que se ordena, y desplazarse
// hasta ella (ordenar por volumen, p. ej.) escondería el nombre.
export default class extends Controller {
  static targets = ['scroll']

  connect() {
    this.update()
    // Poppins llega después del primer pintado y cambia el ancho de la tabla.
    document.fonts?.ready.then(() => this.update())
    // En la portada cada clase de activo tiene su tabla y solo se ve una: la
    // oculta mide 0, así que hay que recalcular cuando aparece, la muestre el
    // desplegable de móvil o las pestañas. Observar el tamaño evita acoplarse a
    // cualquiera de los dos.
    if (typeof ResizeObserver === 'undefined') return

    this.observer = new ResizeObserver(() => this.update())
    this.observer.observe(this.scrollTarget)
  }

  disconnect() {
    this.observer?.disconnect()
  }

  update() {
    const { scrollLeft, scrollWidth, clientWidth } = this.scrollTarget
    // 1px de holgura: con zoom, `scrollLeft` llega con decimales al final.
    this.element.classList.toggle('is-overflowing', scrollLeft + clientWidth < scrollWidth - 1)
  }
}
